import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

type ModuleLimits = {
  SWITCHES: { module: 'SWITCHES'; limit: number };
  WEATHER: { module: 'WEATHER'; limit: number };
};

export const getSystemModuleLimits = async (): Promise<
  ModuleLimits | undefined
> => {
  const { data }: { data: ModuleLimits } = await axios.get(
    `/api/system-modules/limits`
  );
  return data as ModuleLimits;
};

type QueryFnType = typeof getSystemModuleLimits;

type UseSystemModuleLimitsOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useSystemModuleLimits = ({
  config,
}: UseSystemModuleLimitsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['systemModuleLimits'],
    queryFn: () => getSystemModuleLimits(),
    ...config,
  });
};
